<script lang="ts">
import { TypographyTags } from '@/utils/accessibility';
import { BuilderComponent } from '@/utils/cms';

export const Header3Registration: BuilderComponent = {
  name: 'Header3',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Header 3 text here' } },
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
};
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    headerTag?: TypographyTags;
  }>(),
  {
    headerTag: 'h3',
  },
);
</script>

<template>
  <component
    :is="headerTag"
    class="text-2xl font-semibold leading-7 header-3 font-gelica lg:leading-9"
  >
    <slot />
  </component>
</template>

<style scoped>
.header-3 {
  @apply mb-0;
}
@media (min-width: 1024px) {
  .header-3 {
    font-size: 32px;
  }
}
</style>
